module.exports = __webpack_public_path__ + "img/6b75bf1e18840ffb0d2e7839cdedcb89.png";